import { newId } from './ids';

const DEVICE_KEY = 'lk.deviceId';
const TRUSTED_KEY = 'lk.trustedProfile';
const PASSKEY_KEY = 'lk.passkey';

/**
 * Стабільний id пристрою. Живе в localStorage: якщо його стерти,
 * дитина просто ще раз введе PIN — нічого страшного не станеться.
 * Контракт вимагає 8..64 символів, uuid підходить.
 */
export function getDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_KEY);
    if (existing && existing.length >= 8) return existing;
    const created = newId();
    localStorage.setItem(DEVICE_KEY, created);
    return created;
  } catch {
    // Приватний режим без localStorage — id на час сесії вкладки.
    return newId();
  }
}

/** Кого востаннє обирали на цьому пристрої — щоб одразу підсвітити картку. */
export function getTrustedProfile(): string | null {
  try {
    return localStorage.getItem(TRUSTED_KEY);
  } catch {
    return null;
  }
}

export function rememberTrustedProfile(profileId: string): void {
  try {
    localStorage.setItem(TRUSTED_KEY, profileId);
  } catch {
    /* пристрій не дає зберігати — не критично */
  }
}

export function forgetTrustedProfile(): void {
  try {
    localStorage.removeItem(TRUSTED_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * Чи бачив цей пристрій робочий passkey — ставиться після успішної реєстрації
 * ключа або входу за ним.
 *
 * Потрібно рівно для того, щоб кнопка «Face ID» не стояла на екрані входу в
 * дитини: сервер підказати не може (він відповідає однаково всім, інакше
 * перебором можна дізнатись, у кого є ключі), а самих ключів браузер до
 * `navigator.credentials.get()` не показує. Прапорець стерли — вхід за PIN
 * лишається, ключ додається в кабінеті батьків за два дотики.
 */
export function hasLocalPasskey(): boolean {
  try {
    return localStorage.getItem(PASSKEY_KEY) === '1';
  } catch {
    return false;
  }
}

export function rememberLocalPasskey(): void {
  try {
    localStorage.setItem(PASSKEY_KEY, '1');
  } catch {
    /* пристрій не дає зберігати — кнопка просто не з'явиться */
  }
}

export function forgetLocalPasskey(): void {
  try {
    localStorage.removeItem(PASSKEY_KEY);
  } catch {
    /* ignore */
  }
}
